import {
  PartnerResourceModel,
  TechLibraryDocumentModel,
  TechLibraryDocumentType,
} from '@cas/config/documents';
import { CollectionFilteredModel, customerApi, QueryTag } from '../api';
import { FiltersState } from '../slices/filtersSlice';
import { getUrlParams } from './helpers';

export const DocumentTagTechLibrary = 'TECH_LIBRARY';
export const DocumentTagPartnerResources = 'PARTNER_RESOURCES';

export type TechLibraryQueryParams = Partial<
  Pick<FiltersState, 'techLibDocumentTypes' | 'techLibProducts' | 'techLibProductFamilies'>
>;

export const documentTypesTechnicalLibrary = [
  TechLibraryDocumentType.ReleaseNote,
  TechLibraryDocumentType.SystemDiagram,
  TechLibraryDocumentType.TechBulletin,
  TechLibraryDocumentType.TechSpecification,
  TechLibraryDocumentType.ProductLifecycle,
];

export const documentTypesPartnerResources = [
  TechLibraryDocumentType.PartnerMarketingAssets,
  TechLibraryDocumentType.PartnerPromotional,
  TechLibraryDocumentType.PartnerTraining,
  TechLibraryDocumentType.PartnerTools,
  TechLibraryDocumentType.PartnerOther,
];

export type PartnerResourcesQueryParams = Partial<
  Pick<FiltersState, 'partnerResourceTypes' | 'partnerResourceFileTypes'>
>;

export const documentsApi = customerApi.injectEndpoints({
  endpoints: build => ({
    getTechDocs: build.query<
      CollectionFilteredModel<TechLibraryDocumentModel>,
      TechLibraryQueryParams
    >({
      query: query => ({
        url: 'api/documents/techlibrary',
        params: getUrlParams(query),
      }),
      providesTags: (result, error, docType) =>
        error
          ? []
          : [QueryTag.TenantCache, { type: QueryTag.Document, id: DocumentTagTechLibrary }],
    }),
    getPartnerResources: build.query<
      CollectionFilteredModel<PartnerResourceModel>,
      PartnerResourcesQueryParams
    >({
      query: query => ({
        url: 'api/documents/partnerdocs',
        params: getUrlParams(query),
      }),
      providesTags: (result, error, docType) =>
        error
          ? []
          : [QueryTag.TenantCache, { type: QueryTag.Document, id: DocumentTagPartnerResources }],
    }),
  }),
  overrideExisting: false,
});

export const { useGetTechDocsQuery, useGetPartnerResourcesQuery } = documentsApi;
